/* eslint-disable react/prop-types */
import React from "react";
import { Route, Routes, Redirect, Navigate } from "react-router-dom";
import PrivateRoute from "./PrivateRoute";
import AlgoPrivateRoute from "./AlgoPrivateRoute";
import BrokerProtectedRoute from "./BrokerProtectedRoute";
import Dashboard from "../components/pages/dashboard";
import QuiktradeAlgo from "../components/pages/quiktrade-algo/create-strategy";
import Pricing from "../components/pages/pricing";
import Subscriptions from "../components/pages/subscriptions";
import BrokerAccounts from "../components/pages/settings/BrokerAccounts";
import BrokerAccountsSplitPage from "../components/pages/settings/BrokerAccountsSplitPage";
import BrokerLogin from "../components/authentication/simple/BrokerLogin";
import Payment from "../components/pages/pricing/Payment";
import Home from "../components/pages/home";
import BrokerSetup from "../components/pages/settings/BrokerSetup";
import ListStrategies from "../components/pages/quiktrade-algo/list-strategies";
import BrokersPage from "../components/pages/quiktrade-algo/brokers";
import SignalsPage from "../components/pages/quiktrade-algo/signals";
import Profile from "../components/pages/profile";
import Refer from "../components/pages/refer";
import LandingDev from "../components/pages/landing/LandingDev";
import ContactUs from "../components/pages/info/ContactUs";
import PrivacyPolicy from "../components/pages/info/PrivacyPolicy";
import TermsCondition from "../components/pages/info/TermsCondition";
import RefundPolicy from "../components/pages/info/RefundPolicy";
import AboutUs from "../components/pages/info/AboutUs";

const MainRoutes = () => (
  <Routes>
    <Route path="/terminal" element={<BrokerProtectedRoute component={Dashboard} />} />
    <Route path="/algo/create-strategy" element={<BrokerProtectedRoute component={QuiktradeAlgo} />} />
    <Route path="/algo/edit-strategy/:strategyId" element={<BrokerProtectedRoute component={QuiktradeAlgo} />} />
    <Route path="/algo/strategies" element={<BrokerProtectedRoute component={ListStrategies} />} />
    <Route path="/algo/signals" element={<BrokerProtectedRoute component={SignalsPage} />} />
    <Route path="/algo/accounts" element={<BrokerProtectedRoute component={BrokersPage} />} />
    <Route path="/profile" element={<PrivateRoute component={Profile} />} />
    <Route path="/pricing" element={<PrivateRoute component={Pricing} />} />
    <Route path="/payment" element={<PrivateRoute component={Payment} />} />
    <Route path="/subscriptions" element={<PrivateRoute component={Subscriptions} />} />
    <Route path="/refer" element={<PrivateRoute component={Refer} />} />
    <Route path="/broker-setup" element={<PrivateRoute component={BrokerSetup} />} />
    <Route path="/home" element={<PrivateRoute component={Home} />} />
    <Route path="/broker-login" element={<PrivateRoute component={BrokerAccountsSplitPage} />} />
    <Route path="*" element={<Navigate to="/errors/404" replace />} />
  </Routes>
);

export default MainRoutes;
